import { useRef, useState } from "react";
import Autocomplete from "./Autocomplete";
import List from "./List.js";
import { controlOptions } from "../util/reducer";
import { Mui, MuiIcons } from '@osu/react-ui'
import ResetDefaults from "./ResetDefaults.js";
import { cardActionsSx } from "../styles/responsiveness.js";
import Validator from "./Validator.js";
import useLinks from "../hooks/useLinks.js";
import Unsaved from "./Unsaved.js";

function Form({ autocompleteRef }) {
  const [modalOpen, setModalOpen] = useState(false);
  const { preferencesState, updateLinks, onSubmit, onReset, saveDisabled, errorMessage, infoMessage, successMessage, isLoading, isSuccess } = useLinks()
  const alertRef = useRef();
  const pendingLinksTouchedRef = useRef(false);
  const [unsavedOpen, setUnsavedOpen] = useState(false);
  const handleSave = (event) => {
      if(pendingLinksTouchedRef?.current) {
        setUnsavedOpen(true);
      } else {
        onSubmit(event)
      }
  }

  return (
    <Validator alertRef={alertRef} isLoading={isLoading} errorMessage={errorMessage} infoMessage={infoMessage} successMessage={successMessage}>
      <List
        list={preferencesState?.list ?? []}
        updateLinks={updateLinks}
        lastAction={preferencesState?.lastAction}
        isLoading={isLoading}
        isSuccess={isSuccess}
      />
      <Autocomplete
        autocompleteRef={autocompleteRef}
        pendingLinksTouchedRef={pendingLinksTouchedRef}
        sortedLinks={preferencesState?.list ?? []}
        onAdd={(links = []) => {
          updateLinks({
            type: controlOptions.add,
            links: links,
          });
        }}
      />
      <Mui.Divider className="margin-bottom-1" />
      <Unsaved
        open={unsavedOpen}
        onClose={() => setUnsavedOpen(false)}
        onConfirm={(event) => {
          setUnsavedOpen(false);
          onSubmit(event);
        }}
      />
      <Mui.CardActions sx={cardActionsSx} className="padding-x-0">
        <ResetDefaults
          open={modalOpen}
          setOpen={setModalOpen}
          onSubmit={() => {
            onReset()
            setModalOpen(false);
          }}
        />
        <Mui.Button disabled={saveDisabled} onClick={handleSave} startIcon={<MuiIcons.Save />} variant="contained">Save Quick Links</Mui.Button>
      </Mui.CardActions>
    </Validator>
  );
}

export default Form;
